"use strict";

document.addEventListener('DOMContentLoaded', _ => {
	// should be called on every page to transfer Aklamio codes from landing pages to other pages like forms.
	const aklamioTracking = new AklamioTracker();
}, {passive: true, once: true});

export default class AklamioTracker {
	constructor() {
		this._AklamioParams = ['aid'];
		this._URLSearchParams = new URLSearchParams(window.location.search);
		this.updateStoredAklamioParams();
	}

	updateStoredAklamioParams() {
		this._AklamioParams.forEach(async param => {
			if (this._URLSearchParams.has(param)) {
				localStorage.setItem(param, this._URLSearchParams.get(param));
			}
		})
	}

	getStoredAklamioParams() {
		const aklamioItems = {};
		this._AklamioParams.forEach(async param => {
			if (localStorage.getItem(param) !== null) {
				aklamioItems[param] = localStorage.getItem(param);
			}
		});
		return aklamioItems
	}
}
